import { axiosInstanceApiNestingale } from '../axios'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { LifeStyleImage } from '../types/designLifeStyleImages';
export const useLifeStyleImages = (templateId: string | undefined) => {
  return useQuery({
    queryKey: ['lifeStyleImages', templateId],
    queryFn: async () => {
      if (!templateId) throw new Error('templateId is required');

      const { data } = await axiosInstanceApiNestingale.get(
        `v1/api/designLifeStyleImages?templateId=${templateId}`,
        {
          // headers: {
          //   'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf',
          // },
        }
      );
      return data;
    },
    enabled: !!templateId, // don't run until templateId is set
    refetchOnWindowFocus: false,
  });
};

export const useDeleteLifestyleImage = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string, { previousLifeStyleImages?: LifeStyleImage[] }>({
    mutationFn: async (id: string) => {
      await axiosInstanceApiNestingale.delete(`v1/api/designLifeStyleImages/${id}`, {
        // headers: {
        //     'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf',
        // },
      });
    },

    onMutate: async (id: string) => {
      await queryClient.cancelQueries({ queryKey: ['lifeStyleImages'] });

      const previousLifeStyleImages = queryClient.getQueryData<LifeStyleImage[]>(['lifeStyleImages']);

      queryClient.setQueryData<LifeStyleImage[]>(['lifeStyleImages'], (old = []) =>
        old.filter((lifeStyleImages: LifeStyleImage) => lifeStyleImages?.designLifeStyleImageId !== id)
      );

      toast.success('Lifestyle image deleted', {
        autoClose: 5000,
        position: 'top-right',
        toastId: id,
        // If you want to use a custom undo UI, use a custom toast component instead of `action`
      });



      return { previousLifeStyleImages };
    },

    onError: (_err, _id, context) => {
      if (context?.previousLifeStyleImages) {
        queryClient.setQueryData(['lifeStyleImages'], context.previousLifeStyleImages);
      }
      toast.error('Failed to delete lifestyle image');
    },

    onSettled: () => {
      // No-op
    },
  });
};

interface UpdatePayload {
  designLifeStyleImageId: any;
  aiGeneratedData: any;
}

export const useUpdateLifeStyleImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ designLifeStyleImageId, aiGeneratedData }: UpdatePayload) => {
      const { data } = await axiosInstanceApiNestingale.put(
        `v1/api/designLifeStyleImages/${designLifeStyleImageId}`,
        { aiGeneratedData }
      );
      return data;
    },

    // Optimistic Update
    onMutate: async ({ designLifeStyleImageId, aiGeneratedData }) => {
      await queryClient.cancelQueries({ queryKey: ['lifeStyleImages'] }); // optional fine-tuning with templateId if needed

      const previousData = queryClient.getQueryData<any[]>(['lifeStyleImages']);

      // Optimistically update
      queryClient.setQueryData(['lifeStyleImages'], (old: any[]) => {
        if (!old) return [];

        return old.map((item) =>
          item.designLifeStyleImageId === designLifeStyleImageId
            ? { ...item, aiGeneratedData }
            : item
        );
      });

      return { previousData };
    },

    onError: (err, variables, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(['lifeStyleImages'], context.previousData);
      }
    },

    onSettled: () => {
      // no-op
    },
  });
};